import React, { useEffect, useState } from "react";
import "./css/drawingModal.css";
import PropTypes from "prop-types";
import ModalContent from "../modalContent/modalContent";

const DrawingsModal = ({ drawing, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setTimeout(() => setVisible(true), 10);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(onClose, 300);
  };

  if (!drawing) return null;


  return (
    <>
      <div
        className={`modal-backdrop fade ${visible ? "show" : ""}`}
        onClick={handleClose}
      />

      <div
        className={`modal fade slide-from-top ${
          visible ? "show d-block" : "d-block"
        }`}
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content modal-hv">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              />
            </div>

            <div className="modal-body text-center">
              <ModalContent
                image={drawing.img}  
                title={drawing.title} 
                publisher={drawing.technique} 
                country={drawing.measures}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

DrawingsModal.propTypes = {
    drawing: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
  };
  

export default DrawingsModal;
